import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { overlay } from 'overlay-kit';
import { ISSUED_VOUCHER_QUERY_KEY } from '@/shared/features/phone-verification/utils';
import { PhoneVerificationRewardModal } from './PhoneVerificationRewardModal';

/**
 * 휴대폰 인증으로 발급된 이용권의 사용 여부를 **복귀한 화면 위에서** 묻는다.
 *
 * PRD(솔루션 1·2)는 "인증 완료 후 원래 위치로 복귀 → 그 위치에서 사용 여부 확인" 순서다.
 * 인증 페이지가 직접 모달을 띄우면 사용자를 그 자리에 붙잡아 두게 되므로,
 * 인증 완료는 목적지로 보내기만 하고 모달은 앱 레벨인 여기서 연다.
 *
 * 신호는 목적지 query 의 `issuedVoucherId` 다. 사용자가 모달을 닫을 때만 이 신호를
 * 소비한다. 따라서 닫기 전 새로고침은 같은 보상 모달을 다시 연다.
 */
export const PhoneVerificationRewardModalGate = () => {
  const router = useRouter();
  const issuedVoucherId = router.query[ISSUED_VOUCHER_QUERY_KEY];
  const openedRef = useRef(false);
  useEffect(() => {
    if (!router.isReady || openedRef.current) return;
    if (typeof issuedVoucherId !== 'string' || !issuedVoucherId) return;
    openedRef.current = true;
    overlay.open(({
      unmount
    }) => <PhoneVerificationRewardModal voucherHashId={issuedVoucherId} onDismiss={async () => {
      unmount();
      const {
        [ISSUED_VOUCHER_QUERY_KEY]: _removed,
        ...restQuery
      } = router.query;
      await router.replace({
        pathname: router.pathname,
        query: restQuery
      }, undefined, {
        shallow: true
      });
    }} onNavigate={unmount} />);
  }, [issuedVoucherId, router]);
  return null;
};